const getPathSegments = (path) => {
  if (Array.isArray(path)) {
    return path
  }

  if (typeof path !== 'string') {
    return [path]
  }

  const segments = []
  let current = ''
  let index = 0

  while (index < path.length) {
    const char = path[index]

    if (char === '.') {
      if (current) {
        segments.push(current)
        current = ''
      }
      index += 1
      continue
    }

    if (char === '[') {
      if (current) {
        segments.push(current)
        current = ''
      }

      index += 1

      if (index >= path.length) {
        break
      }

      const quote = path[index]

      if (quote === '"' || quote === "'") {
        index += 1
        let value = ''

        while (index < path.length) {
          const quotedChar = path[index]

          if (quotedChar === '\\' && index + 1 < path.length) {
            value += path[index + 1]
            index += 2
            continue
          }

          if (quotedChar === quote) {
            index += 1
            break
          }

          value += quotedChar
          index += 1
        }

        while (index < path.length && path[index] !== ']') {
          index += 1
        }

        segments.push(value)
        index += 1
        continue
      }

      let value = ''

      while (index < path.length && path[index] !== ']') {
        value += path[index]
        index += 1
      }

      segments.push(value.trim())
      index += 1
      continue
    }

    current += char
    index += 1
  }

  if (current) {
    segments.push(current)
  }

  return segments
}

export const _get = (object, path, defaultValue) => {
  const segments = getPathSegments(path)
  let current = object

  for (let index = 0; index < segments.length; index += 1) {
    if (current == null) {
      return defaultValue
    }

    current = current[segments[index]]
  }

  return current === undefined ? defaultValue : current
}
